import { render } from "./Tag.vue?vue&type=template&id=5a59912c&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=5a59912c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a59912c"

export default script